import {
  ApiDataProcessorConfiguration,
  ApiReturnDataProcessorConfiguration,
} from '@highimpact-frontend/api-types';
import { api_dataprocessors } from '../../../api-commons';
import { IDataProcessorConfigurationService } from './IDataProcessorConfigurationService';

class DataProcessorConfigurationService
  implements IDataProcessorConfigurationService
{
  async getAll(
    projectId: number,
    siteId: number
  ): Promise<ApiReturnDataProcessorConfiguration[]> {
    const { data } = await api_dataprocessors.get<
      ApiReturnDataProcessorConfiguration[]
    >(`/projects/${projectId}/sites/${siteId}/dataprocessor-configurations`);
    return data;
  }

  async get(
    projectId: number,
    siteId: number,
    configId: number
  ): Promise<ApiReturnDataProcessorConfiguration> {
    const { data } =
      await api_dataprocessors.get<ApiReturnDataProcessorConfiguration>(
        `/projects/${projectId}/sites/${siteId}/dataprocessor-configurations/${configId}`
      );
    return data;
  }

  async create(
    projectId: number,
    siteId: number,
    config: ApiDataProcessorConfiguration
  ): Promise<ApiDataProcessorConfiguration> {
    const { data } =
      await api_dataprocessors.post<ApiDataProcessorConfiguration>(
        `/projects/${projectId}/sites/${siteId}/dataprocessor-configurations`,
        config
      );
    return data;
  }

  async update(
    projectId: number,
    siteId: number,
    configId: number,
    config: ApiDataProcessorConfiguration
  ): Promise<ApiDataProcessorConfiguration> {
    const { data } =
      await api_dataprocessors.put<ApiDataProcessorConfiguration>(
        `/projects/${projectId}/sites/${siteId}/dataprocessor-configurations/${configId}`,
        config
      );
    return data;
  }

  async delete(
    projectId: number,
    siteId: number,
    configId: number
  ): Promise<void> {
    await api_dataprocessors.delete(
      `/projects/${projectId}/sites/${siteId}/dataprocessor-configurations/${configId}`
    );
  }
}

const DataProcessorConfigurationServiceInstance =
  new DataProcessorConfigurationService();

export default DataProcessorConfigurationServiceInstance;
